import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ExternalApplicationCreateForm from '@views/external-applications/ExternalApplicationCreateForm';
import ExternalApplicationUpdateForm from '@views/external-applications/ExternalApplicationUpdateForm';

export default class ExternalApplications extends AbstractController {
    protected controllerName = 'ExternalApplications';

    protected getDefaultCreateFormComponent() {
        return ExternalApplicationCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return ExternalApplicationUpdateForm;
    }
}
